var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#27cf4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "note-fill",
    transform: "translate(453.976 910.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1989",
    "data-name": "Rectangle 1989",
    width: 28,
    height: 28,
    transform: "translate(0.024 -0.355)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M50.966,32H33.724A1.725,1.725,0,0,0,32,33.724V50.966a1.725,1.725,0,0,0,1.724,1.724H45.436a1.716,1.716,0,0,0,1.219-.505l5.53-5.53a1.716,1.716,0,0,0,.505-1.219V33.724A1.725,1.725,0,0,0,50.966,32ZM38.9,38.035h6.9a.862.862,0,0,1,0,1.724H38.9a.862.862,0,0,1,0-1.724Zm3.448,8.621H38.9a.862.862,0,0,1,0-1.724h3.448a.862.862,0,0,1,0,1.724ZM38.9,43.207a.862.862,0,0,1,0-1.724h6.9a.862.862,0,0,1,0,1.724Zm6.9,7.4V45.792h4.817Z",
    transform: "translate(-28.321 -28.701)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffered);
export default __webpack_public_path__ + "static/media/offered.9c4d45c27c0f32fd4bfb2f8c18413189.svg";
export { ForwardRef as ReactComponent };